import { copyTextToClipboard } from "@areahub/common";
import { Link } from "@areahub/icons";
import { Box, BoxProps, Text, VStack } from "@chakra-ui/react";

export interface CopyLinkButtonProps extends BoxProps {
  link?: string;
}

export const CopyLinkButton = (props: CopyLinkButtonProps) => {
  const { link, onClick, ...rest } = props;

  const onButtonClick: CopyLinkButtonProps["onClick"] = (props) => {
    copyTextToClipboard(link || "test");
    onClick && onClick(props);
  };

  return (
    <VStack
      as="button"
      onClick={onButtonClick}
      _hover={{
        color: "blue",
      }}
    >
      <Box
        borderRadius="full"
        background="gray.200"
        p="20px"
        w="60px"
        h="60px"
        position="relative"
        {...{ rest }}
      >
        <Box as={Link} boxSize="20px" background="grey.500" />
      </Box>
      <Text fontSize="md" fontWeight="medium">
        Copy Link
      </Text>
    </VStack>
  );
};
